
import { useContext, useEffect, useState } from 'react';

import styles from './HomePage.module.css';
import HomePTopSlides from './HomePTopSlides';
import SwiperSection from '../ForAllComponents/SwiperSection';
import HomePBottomSlides from './HomePBottomSlides';
import { RestMenuContext } from '../Contexts/RestMenu_Context';
import MyFunctions from '../Functions/MyFunctions';
import utilsHomePage from '../Connections/_Utils/utilsHomePage';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const HomePage = (props) => {

    const [restMenu, setRestMenu, getMenu] = useContext(RestMenuContext)
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);

    const [homeP, setHomeP] = useState()
    const [loading, setLoading] = useState(true);
    const [randomProducts, setRandomProducts] = useState([]);

    useEffect(() => {
        if (restMenu) {
            setRandomProducts(MyFunctions.getRandomProductsToList(restMenu, 10));

            setLoading(false);

        } else {
            getMenu();
        }
    }, [restMenu, setRestMenu]);

    useEffect(() => {
        const getHomP = async () => {
            let tempHomP = await utilsHomePage.getHomePage();
            setHomeP(tempHomP)

            setCurrentPage({ ...tempHomP, pageTYp: "" });

        }
        getHomP();
    }, []);


    return (
        !loading && homeP &&
        <>
            <HomePTopSlides topImages={homeP.topImages} />
            {homeP.sections.map((section, index) => {
                let itmsLst;
                if (section.selectionType === "1") {
                    itmsLst = MyFunctions.getRandomItems(section.items, section.items.length)
                }
                else if (section.selectionType === "2") {
                    itmsLst = section.items.sort((a, b) => {
                        if (a.parentId < b.parentId) return -1;
                        if (a.parentId > b.parentId) return 1;
                        return 0;
                    });

                }
                else {
                    itmsLst = section.items;
                }

                return (
                    <SwiperSection key={index}
                        theSectionHeader={{
                            mainHead: section.sectionHead,
                            secondHead: section.slideSubTxt
                        }}
                        mnuItemMainImg={restMenu.mnuItemMainImg}
                        getByIds={true}
                        itemsOfSection={itmsLst}
                    />
                )
            })
            }


            <SwiperSection
                theSectionHeader={{
                    mainHead: "עוד מוצרים",
                    secondHead: ""
                }}
                mnuItemMainImg={restMenu.mnuItemMainImg}
                itemsOfSection={randomProducts}
            />

            <div className={"seperatorDubleLine"}></div>

            {mobiOrNot &&
                <>
                    <div className={"spaceButtomBig"}></div>
                    <div className={"spaceButtomBig"}></div>
                    <div className={"spaceButtomBig"}></div>
                </>
            }
            <HomePBottomSlides bottomImages={homeP.bottomImages} />
        </>
    );
}

export default HomePage;
